import { useParams } from "react-router-dom";
import { ClientJobsContainer } from "./jobsContainer/clientJobsContainer";

export default function ClientJobs() {
  const { id } = useParams();
  return <ClientJobsContainer clientId={Number(id)} />;
}
